// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class U16 implements flatbuffers.IUnpackableObject<U16T> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): U16 {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsU16(bb: flatbuffers.ByteBuffer, obj?: U16): U16 {
    return (obj || new U16()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsU16(bb: flatbuffers.ByteBuffer, obj?: U16): U16 {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new U16()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  static startU16(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt16(0, value, 0);
  }

  static endU16(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createU16(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    U16.startU16(builder);
    U16.addValue(builder, value);
    return U16.endU16(builder);
  }

  unpack(): U16T {
    return new U16T(this.value());
  }

  unpackTo(_o: U16T): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): U16T {
    const t = new U16T();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class U16T implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return U16.createU16(builder, this.value);
  }

  clone(): U16T {
    const obj = new U16T();
    obj.value = this.value;
    return obj;
  }

  equals(other: U16T): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyU16(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
